import { useEffect } from 'react';
import ClickableZone from '../../../components/stateless/clickableZone/ClickableZone';
import PublicPage from '../../../layout/publicPageLayout/PublicPageLayout';
import './About.scss';
import { Card, GridLayout, GridLayoutItem } from '@progress/kendo-react-layout';
import { APISettings } from '../../../config/ApiSettings';
import HtmlRender from '../../../components/stateless/htmlRender/HtmlRender';
import { CmsItem } from '../../../utilities/interfaces/CmsItem';
import CustomDialog from '../../../components/stateless/dialog/CustomDialog';
import RichTextEditor from '../../../components/stateful/richTextEditor/RichTextEditor';
import { useAboutController } from './AboutController';
import { Skeleton } from '@progress/kendo-react-indicators';

export const About = (props: any) => {
    //#region functions and state
    const {
        //functions
        toggleCmsEdit,
        handleCmsItemClick,
        onSave,
        getAllCmsItems,
        checkIfAdmin,
        // state
        cmsText,
        cmsTitle,
        cmsValues,
        editCmsOpen,
        isAdmin,
    } = useAboutController();
    //#endregion

    useEffect(() => {
        let apiSettings = new APISettings();
        apiSettings.getApiURL();
        checkIfAdmin();
        if (cmsValues.length < 1) {
            getAllCmsItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    function renderAbout() {
        return (
            <div className='main-content home-body'>
                <GridLayout
                    align={{ horizontal: "stretch" }}
                    cols={[{ width: "10%" }, { width: "80%" }, { width: "10%" }]}
                    gap={{ rows: 3, cols: 3 }}
                >
                    {cmsValues.length < 1 ? (
                        <GridLayoutItem col={2} row={3} className='about-header'>
                            <Card className='first-card'>
                                <Skeleton shape={'rectangle'} style={{ width: '60%', height: 40 }} />
                                <Skeleton shape={'text'} style={{ width: '0%' }} />
                                <Skeleton shape={'text'} style={{ width: '70%' }} />
                                <Skeleton shape={'text'} style={{ width: '80%' }} />
                                <Skeleton shape={'text'} style={{ width: '70%' }} />
                                <Skeleton shape={'text'} style={{ width: '60%' }} />
                                <Skeleton shape={'text'} style={{ width: '80%' }} />
                                <Skeleton shape={'text'} style={{ width: '60%' }} />
                                <Skeleton shape={'text'} style={{ width: '80%' }} />
                            </Card>
                            <Card>
                                <Skeleton shape={'rectangle'} style={{ width: '60%', height: 40 }} />
                                <Skeleton shape={'text'} style={{ width: '0%' }} />
                                <Skeleton shape={'text'} style={{ width: '70%' }} />
                                <Skeleton shape={'text'} style={{ width: '80%' }} />
                                <Skeleton shape={'text'} style={{ width: '70%' }} />
                                <Skeleton shape={'text'} style={{ width: '60%' }} />
                                <Skeleton shape={'text'} style={{ width: '60%' }} />
                                <Skeleton shape={'text'} style={{ width: '80%' }} />
                            </Card>
                        </GridLayoutItem>
                    ) : (
                        cmsValues.map((cmsItem: CmsItem) => {
                            if (cmsItem.id === 1 || cmsItem.id === 2) {
                                return (
                                    <GridLayoutItem key={cmsItem.id} col={2} row={cmsItem.id === 1 ? 2 : 3} className='about-header'>
                                        <ClickableZone onClick={() => handleCmsItemClick(cmsItem.id!)} active={isAdmin}>
                                            <HtmlRender value={cmsItem.cmsItemValue!} className='' />
                                        </ClickableZone>
                                    </GridLayoutItem>
                                );
                            }
                        })
                    )}
                </GridLayout>
                <CustomDialog
                    open={editCmsOpen}
                    hideButtons
                    toggleDialog={toggleCmsEdit}
                    cancelAction={toggleCmsEdit}
                    title={`Edit ${cmsTitle}`}
                    size='medium'
                >
                    <RichTextEditor content={cmsText ?? ''} height={'70vh'} onSave={onSave}></RichTextEditor>
                </CustomDialog>
            </div>
        );
    }

    return <PublicPage children={renderAbout()} />;
};

export default About;
